var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('formulate-input',_vm._g(_vm._b({attrs:{"type":"number","value":_vm.value},on:{"input":_vm.handleInput}},'formulate-input',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }